"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserUploadDialog = exports.dispenserUploadValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const file_input_1 = require("./file-input");
var validation_1 = require("./validation");
Object.defineProperty(exports, "dispenserUploadValidationSchema", { enumerable: true, get: function () { return validation_1.dispenserUploadValidationSchema; } });
const DispenserUploadDialog = (props) => {
    const { initialValues } = props;
    return ((0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid, { columns: [1], children: (0, jsx_runtime_1.jsx)(file_input_1.FileInput, { initialValues: initialValues }) }));
};
exports.DispenserUploadDialog = DispenserUploadDialog;
//# sourceMappingURL=index.js.map